var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "app_container" }, [
    _c("div", { staticClass: "container_top" }, [_vm._t("top")], 2),
    _c("div", { staticClass: "container_main" }, [_vm._t("main")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }